import SideBare from "@/components/News/Parts/sidebare";
import PrePost from '@/components/News/Parts/pre_post';
import Post from "@/components/News/Parts/post";
import axios from 'axios';

export default {
    data() {
        return {
          posts: undefined,
          categories: undefined,
          events: undefined,
          blog: undefined,
          proxyUrl:"https://hanighannoum.nl/proxy.php?url="  ,
          ventaOptions:{  mouseControls: false,
              touchControls: false,
              gyroControls: false,
              minHeight: 500.00,
              minWidth: 200.00,
              scale: 1.00,
              scaleMobile: 1.00,
              color: 0x3fc51a,
              color2: '#0f120f',
              backgroundColor: '#0f120f',
              size: 2.50
  
          },
          medias:undefined
        }
      },
     created(){
       this.getMedias();
     },
      methods: {
       async getPosts() {
          var $this = this;
         return axios.get( this.proxyUrl + 'http://news.mobilityintel.com/wp-json/wp/v2/posts/?categories=2&per_page=100 ').then(function (response) {
              $this.posts = response.data;
            })
            .catch(function (error) {
            });
        },
       async getBlog() {
          var $this = this;
         return axios.get(this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/posts/?categories=3&per_page=100', {
              headers: {
                'Content-Type': 'application/json'
              }
            }, ).then(function (response) {
              $this.blog = response.data;
            })
            .catch(function (error) {
            });
        },
       async getCategories() {
          var $this = this;
        return await axios.get(this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/categories', {
              headers: {
                'Content-Type': 'application/json'
              }
            }, ).then(function (response) {
              // console.log(response)
              $this.categories = response.data;
            })
            .catch(function (error) {});
        },
        getCategoryById(id) {
          return this.categories.filter(
            function (data) {
              return data.id == id
            });
        },
       async getEvents() {
          var $this = this;
         return axios.get( this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/events?filter[orderby]=date&order=asc', {
              headers: {
                'Content-Type': 'application/json'
              }
            }, ).then(function (response) {
              console.log('events')
  
              console.log(response)
              $this.events = response.data;
            })
            .catch(function (error) {
              console.log(error);
            });
        },
         getMedias()  { 
            var $this = this ;
             return axios.get(this.proxyUrl +'http://news.mobilityintel.com/wp-json/wp/v2/media', {
                headers: {
                  'Content-Type': 'application/json'
                }
              }, ).then( (response) => {
                // console.log('getMedia',response)
                this.medias = response.data;
              })
              .catch(function (error) {
                console.log('error',error)
              });
        },
        getMediaById(id){  
          if(this.medias){
            return this.medias.filter(x=>x.id ==id)
          }
        }
      },  watch: { 
      	// medias: function(newVal, oldVal) { // watch it
        //   console.log('medias changed: ', newVal, ' | was: ', oldVal)
        // }
      },
      
      components: {
        SideBare,
        Post,
        PrePost
      },
}


// WEBPACK FOOTER //
// ./src/mixins/posts.js